export const catalog = [
  {
    code: "NAVCLA-33MRE-495605A",
    name: "Aluminum Embossed Plate",
    fullname: "Aluminum Plate w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      500: 2.87,
      1000: 2.60,
      2500: 2.36,
      5000: 2.24,
      10000: 2.02,
    },
  },
  {
    code: "NAVCLA-33MRE-492106A",
    name: "Aluminum Embossed Plate",
    fullname: "Aluminum Plate w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      500: 2.87,
      1000: 2.60,
      2500: 2.36,
      5000: 2.24,
      10000: 2.02,
    },
  },
  {
    code: "NAVCLA-33MRE-444122A",
    name: "Aluminum Embossed Plate",
    fullname: "Aluminum Plate w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      500: 2.87,
      1000: 2.60,
      2500: 2.36,
      5000: 2.24,
      10000: 2.02,
    },
  },
  {
    code: "NAVCLA-34CF-484294A",
    name: "Black Plastic Frame",
    fullname: "Black Plastic Chrome-Faced Frame",
    colors: ["Chrome Faced"],
    type: "customs",
    default_color: "Chrome Faced",
    supportedStores: ["NAVHLK"],
    sizes: {
      1000: 1.50,
      2500: 1.30,
      5000: 1.25,
      10000: 1.14,
    },
  },
  {
    code: "NAVCLA-34PE-450838A",
    name: "Black Plastic Frame",
    fullname: "Black Plastic Frame w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["NAVHLK"],
    sizes: {
      1000: 0.95,
      2500: 0.90,
      5000: 0.80,
      10000: 0.65,
    },
  },
  {
    code: "NAVARRE-COLLISION",
    name: "Full Color Sticker",
    fullname: "2 x 2 Navarre Collision Full Color Sticker",
    colors: ["Full Color"],
    type: "customs",
    default_color: "Full Color",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      1000: 0.54,
      2500: 0.51,
      5000: 0.49,      
    },
  },
  {
    code: "NAVCLA-31SD-504429A",
    name: "CARS Decal",
    fullname: "CARS Decal - 4.5 in. x 1.11 in.",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      2500: 1.13,      
      5000: 1.00, 
    },
  },
  {
    code: "NAVCLA-31SD-504428A",
    name: "TRUCKS Decal",
    fullname: "TRUCKS Decal - 6 in. x 1.48 in.",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      2500: 1.34,      
      5000: 1.15,      
    },
  },
  {
    code: "NAVCLA-31DD-492125A",
    name: "Vinyl Die Cut Decal",
    fullname: "Vinyl Die Cut Decal - 12 in. x 1.875 in.",
    colors: ["White"],
    type: "customs",
    default_color: "White",
    supportedStores: ["NAVCLA","NAVCSU","NAVHLK","NAVBLA","NAVHLA","NAVCLK","VAUMAX","NAVCSL","NAVNLA"],
    sizes: {
      2500: 1.35,  
    },
  },
  {
    code: "59204navarre",
    name: "Laser Engraved Keychain",
    fullname: "Black Avner Curve Keychain w/laser engraved imprint",
    colors: ["Metal"],
    type: "accessory",
    default_color: "Metal",
    sizes: {
      1000: 1.95,
    },
  },
  {
    code: "NAVHLK-PEN-511504Z",
    name: "Premium Metallic Pen",
    fullname: "Black Wrap Elite Slim Premium Metallic Pen w/4cp imprint",
    colors: ["Metallic"],
    type: "accessory",
    default_color: "Metallic",
    sizes: {
      5000: .87,
    },
  },
  {
    code: "NAVHLK-KOOZIE-511662Z",
    name: "Collapsible Can Cooler",
    fullname: "Foamzone Collapsible Can cooler w/4cp imprint",
    colors: ["Blue"],
    type: "accessory",
    default_color: "Blue",
    sizes: {
      2500: 1.55,
    },
  },
   {
    code: "NAVHLK-PLATE-511843A",
    name: "7 in. Plastic Plate",
    fullname: "7 in. Plastic Plate with 287 blue imprint",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      1000: .76,
    },
  },
  {
    code: "NAVHLK-NAPKIN-511844A",
    name: "Colorware Luncheon Napkin",
    fullname: "Colorware Luncheon Napkin w/287 blue imprint",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      2500: .28,
    },
  },
  {
    code: "NAVHLK-CUP-511837A",
    name: "16 oz. Plastic Cup",
    fullname: "Clear 16 oz. Soft-Sided Plastic Cup w/287 blue imprint",
    colors: ["Clear"],
    type: "accessory",
    default_color: "Clear",
    sizes: {
      5100: .32,
    },
  },
  {
    code: "600088V",
    name: "Seat Covers",
    fullname: "No-Slip Plastic Seat Covers (500/roll)",
    colors: ["Plastic"],
    type: "service",
    default_color: "Plastic",
    sizes: {
      500: 65.00,
    },
  },
  {
    code: "3088",
    name: "Floor Mats",
    fullname: "Floor Mats/Coated Paper (500/bx)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      500: 60.00,
    },
  },
  {
    code: "3044",
    name: "Spring Rings",
    fullname: "Metal Spring Rings (250/pk)",
    colors: ["Metal"],
    type: "service",
    default_color: "Metal",
    sizes: {
      250: 13.95,
    },
  },
  {
    code: "SDNRG",
    name: "Service Numbers",
    fullname: "Service Dispatch Numbers (1000/bx)",
    colors: [
      "0000",
      "1000",
      "2000",
      "3000",
      "4000",
      "5000",
      "6000",
      "7000",
      "8000",
      "9000",
    ],
    type: "service",
    default_color: "1000",
    sizes: {
      1: 65.00,
    },
  },
  {
    code: "VT400",
    name: "Stock Stickers",
    fullname: "Kleer-Back Stock Stickers Versa #400 (100/pk)",
    colors: ["Blue", "Green", "Orange", "Red", "White", "Yellow"],
    type: "sales",
    default_color: "Blue",
    sizes: {
      1: 16.95,
    },
  },
  {
    code: "GP200",
    name: "Key Tags",
    fullname: "Key Tag Versa #200 (250/box)",
    colors: [
      "Blue",
      "Gray",
      "Green",
      "Lilac",
      "Lime Green",
      "Orange",
      "Red",
      "Tan",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    sizes: {
      1: 35.95,
    },
  },
  {
    code: "226",
    name: "Combo Key Tags",
    fullname: "Combo Key Tags - Numbered (125/box)",
    colors: [
      "Beige",
      "Blue",
      "Green",
      "Grey",
      "Lilac",
      "Orange",
      "Red",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Beige",
    sizes: {
      1: 65.00,
    },
  },
  {
    code: "3198BY",
    name: "Oval Year Stickers",
    fullname: "Oval Year Stickers (Black/Yellow)  (12/pk)",
    colors: [
      "BY_08",
      "BY_09",
      "BY_10",
      "BY_11",
      "BY_12",
      "BY_13",
      "BY_14",
      "BY_15",
      "BY_16",
      "BY_17",
      "BY_18",
      "BY_19",
      "BY_20",
      "BY_21",
      "BY_22",
      "BY_23",
      "BY_24",
      "BY_25",
      "BY_26",
    ],
    type: "sales",
    default_color: "BY 08",
    sizes: {
      1: 10.99,
    },
  },
  {
    code: "NDESTOCK",
    name: "Night Drop Envelopes",
    fullname: "Night Drop Envelopes (500/bx)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      500: 99.99,
    },
  },
  {
    code: "7290",
    name: "Inspection Form - 3 Part",
    fullname: "Multi-Point Inspection Form - 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 34.14,
    },
  },
  {
    code: "7291",
    name: "Inspection Form - 2 Part",
    fullname: "Multi-Point Inspection Form - 2 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 34.14,
    },
  },
  {
    code: "7292",
    name: "Inspection Form - GM",
    fullname: "Multi-Point Inspection Form (GM) 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 34.14,
    },
  },
  {
    code: "7293",
    name: "Inspection Form CHRYSLER",
    fullname: "Multi-Point Inspection Form (Chrysler) 3 Part (250/pk)",
    colors: ["White"],
    type: "service",
    default_color: "White",
    sizes: {
      250: 34.14,
    },
  },
  {
    code: "GP546",
    name: "Deal Jackets",
    fullname: "Deal Jackets (500/box)",
    colors: [
      "Blue",
      "Buff",
      "Fuchsia",
      "Green",
      "Grey",
      "Lavender",
      "Pink",
      "Salmon",
      "White",
      "Yellow",
    ],
    type: "sales",
    default_color: "Blue",
    sizes: {
      1: 115.00,
    },
  },
  {
    code: "ST740",
    name: "Sport-Tek Micropique Polo",
    fullname: "Sport-Tek® UV Micropique Polo",
    colors: ["Black", "Graphite", "Grey Concrete"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 26.99,
      Medium: 26.99,
      Large: 26.99,
      XLarge: 26.99,
      "2XLarge": 28.99,
      "3XLarge": 31.99,
      "4XLarge": 33.99,
    },
  },
  {
    code: "NKDC1963",
    name: "Nike® Dri-FIT Polo Shirt",
    fullname: "Nike® Dri-FIT Polo",
    colors: ["Anthracite", "Black", "Cool Grey"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 45.99,
      Medium: 45.99,
      Large: 45.99,
      XLarge: 45.99,
      "2XLarge": 47.99,
      "3XLarge": 50.99,
      "4XLarge": 52.99,
      LT: 51.99,
      XLT: 51.99,
      "2XLT": 53.99,
      "3XLT": 56.99,
      "4XLT": 58.99,
    },
  },
  {
    code: "J317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Core Soft Shell Jacket",
    colors: [
      "Battleship Grey",
      "Black",
      "Black Charcoal Heather",
      "Deep Smoke",
      "Pearl Grey Heather",
    ],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 46.99,
      Medium: 46.99,
      Large: 46.99,
      XLarge: 46.99,
      "2XLarge": 48.99,
      "3XLarge": 51.99,
      "4XLarge": 53.99,
      "5XLarge": 55.99,
      "6XLarge": 57.99,
    },
  },
  {
    code: "L317",
    name: "Port Authority® Jacket",
    fullname: "Port Authority® Women's Core Soft Shell Jacket",
    colors: [
      "Battleship Grey",
      "Black",
      "Black Charcoal Heather",
      "Deep Smoke",
      "Pearl Grey Heather",
    ],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 46.99,
      Medium: 46.99,
      Large: 46.99,
      XLarge: 46.99,
      "2XLarge": 48.99,
      "3XLarge": 51.99,
      "4XLarge": 53.99,
    },
  },
  {
    code: "J325",
    name: "Port Authority Vest",
    fullname: "Port Authority® Core Soft Shell Vest",
    colors: ["Battleship Grey", "Black", "Black Charcoal Heather"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 37.99,
      Medium: 37.99,
      Large: 37.99,
      XLarge: 37.99,
      "2XLarge": 38.99,
      "3XLarge": 41.99,
      "4XLarge": 42.99,
    },
  },
  {
    code: "L325",
    name: "Port Authority Vest",
    fullname: "Port Authority® Women's Core Soft Shell Vest",
    colors: ["Battleship Grey", "Black", "Black Charcoal Heather"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 37.99,
      Medium: 37.99,
      Large: 37.99,
      XLarge: 37.99,
      "2XLarge": 38.99,
      "3XLarge": 41.99,
      "4XLarge": 42.99,
    },
  },
  {
    code: "J331",
    name: "Port Authority Jacket",
    fullname: "Port Authority® All-Conditions Jacket",
    colors: ["Black"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 68.99,
      Medium: 68.99,
      Large: 68.99,
      XLarge: 68.99,
      "2XLarge": 70.99,
      "3XLarge": 73.99,
      "4XLarge": 75.99,
    },
  },
  {
    code: "L331",
    name: "Port Authority Jacket",
    fullname: "Port Authority® Women's All-Conditions Jacket",
    colors: ["Black"],
    type: "womens",
    default_color: "Black",
    sizes: {
      Small: 68.99,
      Medium: 68.99,
      Large: 68.99,
      XLarge: 68.99,
      "2XLarge": 70.99,
      "3XLarge": 73.99,
      "4XLarge": 75.99,
    },
  },
  {
    code: "CP90",
    name: "Port Authority Knit Cap",
    fullname: "Port & Company® - Knit Cap",
    colors: ["Athletic Oxford", "Black", "Charcoal Heather"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 10.49,
    },
  },
  {
    code: "C112",
    name: "Port Authority Trucker Cap",
    fullname: "Port Authority® Snapback Trucker Cap",
    colors: ["Black", "Gusty Grey", "Grey Steel"],
    type: "mens",
    default_color: "Black",
    sizes: {
      OSFA: 13.25,
    },
  },
];
